/* eslint-disable no-use-before-define, no-param-reassign */
import io from 'socket.io-client/dist/socket.io.js';

const URL = 'https://api2.timedoctor.com';
const SOCKET = Symbol('socket');
const SOCKET_AVAILABLE = Symbol('socket available');
const QUEUE = Symbol('queue');
const PUSH_TO_QUEUE = Symbol('push to queue');
const DRAIN_QUEUE = Symbol('drain queue');
const MAY_DEFER = Symbol('may defer');
const TOKEN = Symbol('token');
const USER_ID = Symbol('userId');
const WORKSPACE_ID = Symbol('workspaceId');

// removeListener

class SocketService {
  static factory() { // eslint-disable-line no-unused-vars
    'ngInject';

    return function getInstance(token, userId, workspaceId) {
      return new SocketService(token, userId, workspaceId);
    };
  }

  constructor(token, userId, workspaceId) {
    this[SOCKET] = null;
    this[SOCKET_AVAILABLE] = false;
    this[QUEUE] = [];
    this[TOKEN] = token;
    this[USER_ID] = userId;
    this[WORKSPACE_ID] = workspaceId;

    // private methods
    this[PUSH_TO_QUEUE] = pushToQueue.bind(this);
    this[MAY_DEFER] = mayDefer.bind(this);
    this[DRAIN_QUEUE] = drainQueue.bind(this);
  }

  connect() {
    const token = this[TOKEN];
    this[SOCKET] = io.connect(URL, {
      path: '/api/1.0/socket',
      transports: ['websocket', 'polling'],
      query: { token },
    });

    this[SOCKET_AVAILABLE] = true;
    this[DRAIN_QUEUE]();

    return this;
  }

  on(event, cb) {
    this[MAY_DEFER](() => this[SOCKET].on(event, cb));
    return this;
  }

  emit(event, data) {
    this[MAY_DEFER](() => this[SOCKET].emit(event, data));

    return this;
  }

  subscribe(data) {
    this[MAY_DEFER](() => {
      const companyId = this[WORKSPACE_ID];
      const userId = this[USER_ID];

      if (angular.isUndefined(data)) {
        data = { users: [userId], company: companyId };
      }

      this.emit('subscribe', data);
    });

    return this;
  }

  unsubscribe(data) {
    this[MAY_DEFER](() => {
      const companyId = this[WORKSPACE_ID];

      if (angular.isUndefined(data)) {
        data = { company: companyId };
      }

      this.emit('unsubscribe', data);
    });

    return this;
  }
}

// private methods
function pushToQueue(cb) {
  this[QUEUE].push(cb);
}

function mayDefer(fn) {
  if (!this[SOCKET_AVAILABLE]) {
    this[PUSH_TO_QUEUE](fn);
  } else {
    fn();
  }
}

function drainQueue() {
  if (this[SOCKET_AVAILABLE] && this[QUEUE].length) {
    do {
      const cb = this[QUEUE].shift();

      cb();
    } while (this[QUEUE].length);
  }
}

export default SocketService;
